import { Box, Card, Typography } from "@mui/joy";
import { ChevronRight } from "lucide-react";

import { env } from "../../config";
import { Button } from "../../shared";

import loginWelcomeArt from "../../assets/images/login-welcome.png";

const LOGIN_URL = `${env.API_ENDPOINT}/v1/auth/external/cognito`;

export default function Login() {
    return (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, minHeight: "100vh" }}>
            <Box flex={1} display={"flex"} alignItems={"center"} flexDirection={"column"} height={"100%"}>
                <Box width={"100%"} margin={"auto"} maxWidth={400} px={{ xs: 4, md: 0 }} py={{ xs: 8, md: 0 }}>
                    <Typography level="h4" sx={{ maxWidth: 300 }} gutterBottom>
                        Roofin Motion
                    </Typography>
                    <Typography level="h3" sx={{ maxWidth: 300 }}>
                        We handle the chaos—so you can build with confidence.
                    </Typography>
                    <Box mt={3}>
                        <a href={LOGIN_URL}>
                            <Button loadingPosition={"start"} sx={{ mt: 1 }} endDecorator={<ChevronRight size={16} />}>
                                Get to Work
                            </Button>
                        </a>

                        <Typography sx={{ mt: 2 }}>
                            Just getting started? We've got intro videos to help you hit the ground running.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box flex={1} display={{ xs: "none", md: "flex" }} alignItems={"center"}>
                <Card
                    variant="soft"
                    sx={{
                        maxWidth: "90%",
                        flex: 1,
                        height: "90vh",
                        display: "flex",
                        background: "#eeeff1",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={loginWelcomeArt}
                        style={{ width: "100%", objectFit: "cover", maxWidth: 500 }}
                        alt="Working person"
                    />
                </Card>
            </Box>
        </Box>
    );
}
